import { useSignInPage } from '@core/hooks/useSignInPage'
import { useSso } from '@core/hooks/useSso'
import {
  signInSearchSchema,
  ssoPropsFromSearch,
} from '@core/utils/sign-in-search'
import { ContentWithTop } from '@design/components/layouts/content-with-top/ContentWithTop'
import { SignInScreen } from '@design/components/screens/sign-in-screen/SignInScreen'
import { SignedOutIntroHeader } from '@platform/components/layout/IntroHeader'
import { ROUTES } from '@platform/router/paths'
import { createFileRoute, useNavigate } from '@tanstack/react-router'

export const Route = createFileRoute('/(auth)/sign-in')({
  component: RouteComponent,
  validateSearch: (search) => signInSearchSchema.parse(search),
})

const cognitoDomain = import.meta.env.VITE_COGNITO_DOMAIN

function RouteComponent() {
  const navigate = useNavigate()
  const search = Route.useSearch()

  const signInProps = useSignInPage({
    onSuccess: () => navigate({ href: search.redirect || ROUTES.root }),
    forgotPasswordUrl: ROUTES.forgotPassword,
  })
  const sso = useSso({ cognitoDomain, redirect: search.redirect })

  return (
    <ContentWithTop className='h-dvh' top={<SignedOutIntroHeader />}>
      <SignInScreen
        sso={sso}
        {...signInProps}
        {...ssoPropsFromSearch(search)}
      />
    </ContentWithTop>
  )
}
